defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Game/EurojackpotLightningClient',
  [
    'DanskeSpil/Domain/Eurojackpot/Scripts/Models/EurojackpotGame',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Domain/Eurojackpot/Scripts/Helpers/EurojackpotInfo',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Params',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/NumberGames/Scripts/Templates/MultiClient/Client/RotarySelector'
  ],
  function (EurojackpotGame, PlayTogetherDictionary, EurojackpotInfo, Params, Utils, RotarySelector) {

    // Template:
    var EurojackpotLightningClient = function (m, settings, property) {

      // Variables:
      var deferred = m.deferred();

      m.sync([PlayTogetherDictionary.ready, EurojackpotInfo.ready]).then(function () {

        // Feed check:
        if (EurojackpotInfo.isFeedDown()) {
          window.history.back();
        }

        // Client:
        var GameClient = function (m, ignoreSettings, property) {

          // Components:
          var root = {
            controller: function () {
              this.d = property('dictionary');
              this.gameInstanceId = m.prop(Utils.getQueryParam('gameInstanceId'));
              this.game = m.prop(null);
              if (this.gameInstanceId()) {
                this.game(EurojackpotGame.get(this.gameInstanceId()));
              }
              if (!this.game()) {
                this.game(EurojackpotGame.setupGame({
                  gameInstanceId: this.gameInstanceId(),
                  playType: 'Lightning',
                  rowsToGenerate: EurojackpotInfo.getLightningDefaultRowCount(),
                  verticalType: 'playTogether',
                  numberOfDraws: property('numberOfDraws') || -1,
                }));
                Params.set(`gameInstanceId=${this.game().id()}`);
              }

              property('gameModel', this.game);
              property('afterGameModelLoaded')?.();
              this.rows = this.game().rowsToGenerate;
              this.rowsOptions = m.prop(EurojackpotInfo.getLightningOptions());
            },

            view: function (controller) {
              return m('div', [
                RotarySelector(controller.rowsOptions, controller.rows, controller.d('LabelRow' + (controller.rows() !== 1 ? 's' : '')), null, 'eurojackpot'),
                property('campaignTicketCounter')?.({ rows: controller.rows() })
              ]);
            }
          };

          // Return:
          return root;

        };

        deferred.resolve(GameClient(m, settings, property));
      });

      // Return:
      return deferred.promise;
    };

    // Public functions:
    return EurojackpotLightningClient;

  });
